import React from 'react';
import { Container, Card } from 'react-bootstrap';
import PageTitle from '@/common/PageTitle/PageTitle';
import styles from './account-security.module.scss';

const AccountSecurity: React.FC = () => (
  <Container fluid>
    <Card className={styles.card}>
      <Card.Body>
        <Card.Title className={styles.cardTitle}>
          <PageTitle title="Account Security" />
        </Card.Title>
        
        <div className={styles.sectionHeader}>
          <div className={styles.sectionTitle}>Two-step authentication</div>
          <button className={styles.addButton}>+ Add Method</button>
        </div>
        <hr className={styles.divider} />
        <table className={styles.securityTable}>
          <thead>
            <tr>
              <th>Method</th>
              <th>Device</th>
              <th>Date Added</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                SMS <span className={styles.methodBadge}>Default</span>
              </td>
              <td>(481) 491-2048</td>
              <td>January 27, 2025</td>
              <td>...</td>
            </tr>
          </tbody>
        </table>
      </Card.Body>
    </Card>
  </Container>
);

export default AccountSecurity; 